var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("@/assets/images/lexue.png")}}),_c('div',{staticClass:"text"},[_vm._v(" 本书配套视频将于图书上市后开始录制并陆续上线，目前还在建设中，敬请期待~ ")]),_c('div',{staticClass:"buttom",on:{"click":_vm.home}},[_vm._v("返回首页逛逛")])])
}
var staticRenderFns = []

export { render, staticRenderFns }